import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  ButtonModule,
  FormFieldModule,
  FitTextModule,
  DefaultImageModule,
} from '@shared/components/games';
import { CalculatorModule } from '@shared/components/games/calculator/calculator.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { PercentsControllerComponent } from './percents-controller/percents-controller.component';
import { PercentsCorrectAnswerPreviewComponent } from './percents-preview/percents-answer-preview/percents-answer-preview.component';
import { PercentsExamplePreviewComponent } from './percents-preview/percents-example-preview/percents-example-preview.component';
import { PercentsParametersPreviewComponent } from './percents-preview/percents-parameters-preview/percents-parameters-preview.component';
import { PercentsUserAnswerPreviewComponent } from './percents-preview/percents-user-answer-preview/percents-user-answer-preview.component';
import { PercentsSettingsComponent } from './percents-settings/percents-settings.component';
import { GamesSharedModule } from '@games/games-shared/games-shared.module';
import { MathGamesSharedModule } from '@games/games-shared/math-games-shared.module';
import { CalculatorLayoutComponent } from '@shared/components/games/input-layouts/calculator-layout/calculator-layout.component';

@NgModule({
  declarations: [
    PercentsControllerComponent,
    PercentsSettingsComponent,
    PercentsCorrectAnswerPreviewComponent,
    PercentsExamplePreviewComponent,
    PercentsParametersPreviewComponent,
    PercentsUserAnswerPreviewComponent,
  ],
  exports: [
    PercentsControllerComponent,
    PercentsSettingsComponent,
    PercentsCorrectAnswerPreviewComponent,
    PercentsExamplePreviewComponent,
    PercentsParametersPreviewComponent,
    PercentsUserAnswerPreviewComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    ButtonModule,
    FitTextModule,
    NgSelectModule,
    DefaultImageModule,
    FormFieldModule,
    CalculatorModule,
    MathGamesSharedModule,
    CalculatorLayoutComponent,
  ],
})
export class PercentsModule {}
